export const PromotionListColConfig = [
  {
    name_of_db_column: 'name',
    header: 'Name',
    columnFilterPlaceholder: 'Name',
    filterVariant: 'string',
    filterable: true,
    initialSize: 200,
    minSize: 200,
  },
  {
    name_of_db_column: 'promotionType',
    header: 'Type',
    columnFilterPlaceholder: 'Type',
    filterVariant: 'string',
    filterable: true,
    initialSize: 200,
    minSize: 200,
  },
  {
    name_of_db_column: 'noOfStores',
    header: '# Stores',
    columnFilterPlaceholder: '# Stores',
    filterVariant: 'string',
    filterable: true,
    initialSize: 200,
    minSize: 200,
  },
  {
    name_of_db_column: 'percentagePromotionAccepted',
    header: ' % Promotion Accepted',
    columnFilterPlaceholder: '% Promotion Accepted',
    filterable: true,
    initialSize: 200,
    minSize: 200,
  },
  {
    name_of_db_column: 'displayOrder',
    header: 'Display Order',
    columnFilterPlaceholder: 'Display Order',
    filterable: true,
    filterVariant: 'long',
    initialSize: 200,
    minSize: 200,
    filterVariant: 'long',
  },
  {
    name_of_db_column: 'activeStartDate',
    header: 'Start Date',
    columnFilterPlaceholder: 'Start Date',
    filterVariant: 'date',
    initialSize: 330,
    filterable: true,
  },
  {
    name_of_db_column: 'activeEndDate',
    header: 'End Date',
    columnFilterPlaceholder: 'End Date',
    filterVariant: 'date',
    initialSize: 330,
    filterable: true,
  },
  {
    name_of_db_column: 'status',
    header: 'Status',
    columnFilterPlaceholder: 'Status',
    filterVariant: 'string',
    filterable: true,
    initialSize: 200,
    minSize: 200,
  },
]
